import React from 'react';
import { SocialRail } from './SocialIcons';

const Footer = ({ navigate }) => {
  const go = (page, data) => {
    if (typeof navigate === 'function') navigate(page, data);
  };

  return (
    <footer className="bg-primary text-cream">
      <div className="h-[3px] gradient-gold" />

      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-8 md:py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
          <div>
            <p className="text-accent text-[11px] tracking-[0.28em] uppercase font-semibold mb-1.5">Begin your pilgrimage</p>
            <h3 className="font-display text-2xl md:text-3xl text-white leading-tight">Speak with our specialists today</h3>
          </div>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => go('category', { category: 'umrah-packages' })}
              className="btn-lux gradient-gold text-ink px-6 py-3 rounded-sm font-semibold text-sm tracking-wide"
            >
              Browse packages
            </button>
            <a
              href="https://wa.me/6598201134"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-accent/60 text-cream hover:bg-accent hover:text-ink px-6 py-3 rounded-sm font-semibold text-sm tracking-wide transition-colors"
            >
              WhatsApp us
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 pt-12 sm:pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <img src="/logo.jpeg" alt="TM Fouzy Travel" className="h-14 mb-5 rounded-md bg-cream p-1 object-contain" />
            <p className="text-cream/70 text-sm leading-relaxed mb-5">
              Licensed Umrah &amp; Hajj specialists helping pilgrims from Singapore since 2010. Seamless bookings, trusted hotels, and 24/7 support.
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="text-[11px] font-semibold tracking-wide bg-white/10 text-accent border border-accent/30 px-2.5 py-1 rounded-full">UEN 199402129H</span>
              <span className="text-[11px] font-semibold tracking-wide bg-white/10 text-accent border border-accent/30 px-2.5 py-1 rounded-full">Licence TA00898</span>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-1 text-white tracking-wide">Explore</h4>
            <div className="w-10 h-px bg-accent mb-4" />
            <ul className="space-y-2.5 text-cream/70 text-sm">
              <li><button onClick={() => go('landing')} className="hover:text-accent transition-colors">Home</button></li>
              <li><button onClick={() => go('category', { category: 'umrah-packages' })} className="hover:text-accent transition-colors">Umrah Packages</button></li>
              <li><button onClick={() => go('category', { category: 'hajj-packages' })} className="hover:text-accent transition-colors">Hajj Packages</button></li>
              <li><button onClick={() => go('category', { category: 'ziarah-tours' })} className="hover:text-accent transition-colors">Ziarah Tours</button></li>
              <li><button onClick={() => go('shop')} className="hover:text-accent transition-colors">Travel Shop</button></li>
              <li><button onClick={() => go('portal')} className="hover:text-accent transition-colors">My Dashboard</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-1 text-white tracking-wide">Company</h4>
            <div className="w-10 h-px bg-accent mb-4" />
            <ul className="space-y-2.5 text-cream/70 text-sm">
              <li><button onClick={() => go('about')} className="hover:text-accent transition-colors">About Us</button></li>
              <li><button onClick={() => go('contact')} className="hover:text-accent transition-colors">Contact</button></li>
              <li><button onClick={() => go('login')} className="hover:text-accent transition-colors">Login</button></li>
              <li><button onClick={() => go('register')} className="hover:text-accent transition-colors">Register</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-1 text-white tracking-wide">Get in Touch</h4>
            <div className="w-10 h-px bg-accent mb-4" />
            <ul className="space-y-3 text-cream/70 text-sm">
              <li>
                <a href="mailto:enquiry@tmfouzy.sg" className="hover:text-accent transition-colors">enquiry@tmfouzy.sg</a>
              </li>
              <li>
                <a href="tel:+6562948044" className="hover:text-accent transition-colors">+65 6294 8044</a>
              </li>
              <li>
                <a href="https://wa.me/6598201134" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                  WhatsApp +65 9820 1134
                </a>
              </li>
              <li className="leading-relaxed">390 Victoria St #03-15<br />Singapore 188061</li>
            </ul>
            <div className="mt-5">
              <SocialRail tone="footer" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-secondary">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-cream/50 text-xs">
          <p>© {new Date().getFullYear()} TM Fouzy Travel &amp; Tours Pte Ltd. All rights reserved.</p>
          <p>UEN 199402129H · Travel Agent Licence TA00898</p>
          <button
            onClick={() => go('admin-login')}
            className="text-cream/20 hover:text-cream/60 text-[10px] transition-colors">
            Admin
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
